import React from 'react';

const PageHero = ({ badge, title, subtitle, children, className = '' }) => (
  <section className={`pt-32 pb-16 md:pb-20 px-6 md:px-12 text-center max-w-5xl mx-auto ${className}`}>
    {badge && <span className="section-badge mb-6">{badge}</span>}
    {title && (
      <h1 className="text-4xl md:text-6xl lg:text-7xl gradient-heading leading-tight drop-shadow-md">
        {title}
      </h1>
    )}
    {subtitle && (
      <p className="mt-6 md:mt-8 text-lg md:text-xl text-brand-cream-muted font-medium leading-relaxed drop-shadow-sm max-w-3xl mx-auto">
        {subtitle}
      </p>
    )}
    {children}
  </section>
);

export default PageHero;
